<template>
	<gmap-map
		:center="center"
		:options="generalOptions"
		:style="`width: ${width}${unitWidth}; height: ${height}${unitHeight}`"
		:zoom="zoom"
		@center_changed="$emit('on-center-changed', $event)"
	></gmap-map>
</template>

<script>
	function data() {
		return {
			generalOptions: {
				zoomControl: true,
				mapTypeControl: false,
				fullscreenControl: false,
			},
		};
	}

	export default {
		name: 'gmap-components',
		data,
		props: {
			center: {
				default: () => {},
				type: Object,
			},
			height: [Number, String],
			markers: {
				default: () => [],
				type: Array,
			},
			styles: {
				default: () => [],
				type: Array,
			},
			unitHeight: {
				default: 'px',
				type: String,
			},
			unitWidth: {
				default: 'px',
				type: String,
			},
			width: [Number, String],
			zoom: [Number, String],
		},
	};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/shared/gmap-component.vue